import { HeadingText, Button } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import React from 'react'
import * as styles from './totalAmount.css'

interface Props {
  isSmallerScreen: boolean
  formattedCurrentAmount: string
  isAdmin: boolean
  hasFunds: boolean
  transferUrl: string
}

export const CurrentAmount = ({
  isSmallerScreen,
  formattedCurrentAmount,
  isAdmin,
  hasFunds,
  transferUrl,
}: Props) => {
  const displayTransferButton = isAdmin && hasFunds && isSmallerScreen

  return (
    <div className={styles.smallerAmountContainer}>
      <HeadingText
        className={styles.amount}
        as="h3"
        size={isSmallerScreen ? 'sm' : 'lg'}
      >
        {formattedCurrentAmount}
      </HeadingText>
      {displayTransferButton && (
        <Button
          fullWidthOnMobile={false}
          variant="secondary"
          size="sm"
          as="a"
          href={transferUrl}
          role="button"
          data-testid="transferButtonCurrentAmount"
          className={styles.transferButton}
        >
          <Message id="flatProgress.transfer" />
        </Button>
      )}
    </div>
  )
}
